export enum TimetableStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  ARCHIVED = "ARCHIVED",
  GENERATING = "GENERATING",
  FAILED = "FAILED",
}
